import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { isV2 } from "../lib/config";

export type DocStatus = "pending" | "sending" | "accepted" | "rejected" | "unknown" | "blocked" | "cancelled";
export interface EinvSettings {
  enabled: boolean; environment: "simulate" | "live"; sendMode: "auto" | "manual"; taxpayerType: "income" | "sales";
  incomeSourceSequence: string; taxNumber: string; legalName: string; clientId: string; secretSet: boolean; baseUrl: string; namedBuyerOverFils: number; enabledSince: string | null; pausedReason: string | null;
}
export interface EinvDoc {
  id: string; kind: "invoice" | "credit"; doc_number: string; uuid: string; icv: number; environment: string; status: DocStatus; total: number; qr: string | null;
  error_code: string | null; error_message: string | null; attempts: number; next_attempt_at: string | null; created_at: string; sent_at: string | null; note: string | null; has_xml: boolean;
}
export const einvKey = ["einvoice"] as const;

export const useEinvSettings = () =>
  useQuery({ queryKey: [...einvKey, "settings"], enabled: isV2(), queryFn: () => api.get<{ settings: EinvSettings; missing: string[]; suggest: { taxNumber: string; legalName: string }; counts: Array<{ status: string; n: number }>; productionUrl: string }>("/einvoice/settings") });

export const useEinvDocs = (status: string, kind: string, q: string, page: number) =>
  useQuery({
    queryKey: [...einvKey, "docs", status, kind, q, page], enabled: isV2(), placeholderData: keepPreviousData, refetchInterval: 15_000,
    queryFn: () => api.get<{ total: number; page: number; documents: EinvDoc[]; counts: Array<{ status: string; n: number }>; environment: string }>(`/einvoice/documents?${new URLSearchParams({ ...(status ? { status } : {}), ...(kind ? { kind } : {}), ...(q ? { q } : {}), page: String(page) })}`),
  });
